import EntitiesResource from '../entities'
import StateResource from '../state'
import { DefaultInput, DefaultFormSelect, DefaultCheckbox, DefaultFormAutocomplete, DefaultToolTip, DefaultTextarea } from './index'

const booleanSelectOptions = [
    { value: 1, text: 'Enabled' },
    { value: 0, text: 'Disabled' },
]

const orgTypeOptions = [
    { value: 1, text: 'Corporation' },
    { value: 2, text: 'Sole-Proprietorship' },
    { value: 3, text: 'Individual' },
]

const entityTypeOptions = [
    { value: 1, text: 'Client' },
    { value: 2, text: 'Project' },
    { value: 3, text: 'Control Group' },
    { value: 4, text: 'Payroll Company' },
]

const industryTypeOptions = [
    { value: 1, text: 'N/A' },
    { value: 2, text: 'Entertainment' },
    { value: 3, text: 'Non-Entertainment' },
    { value: 4, text: 'Feature Film' },
    { value: 5, text: 'VideoTape' },
    { value: 6, text: 'Scripted Television' },
]

const payFrequencyTypeOptions = [
    { value: 1, text: 'WEEKLY' },
    { value: 2, text: 'BIWEEKLY' },
    { value: 3, text: 'SEMIMONTHLY' },
    { value: 4, text: 'MONTHLY' },
    { value: 5, text: 'DAILY' },
    { value: 6, text: 'QUARTERLY' },
]

const defaultWeekEndingOptions = [
    { value: 10, text: 'Saturday' },
    { value: 11, text: 'Sunday' },
    { value: 12, text: 'Monday' },
    { value: 13, text: 'Tuesday' },
    { value: 14, text: 'Wednesday' },
    { value: 15, text: 'Thursday' },
    { value: 16, text: 'Friday' },
]

const companyOptions = [{ value: 1, text: 'Revolution' }]

const countryOptions = [
    { value: 1, text: 'US' },
    { value: 2, text: 'Canada' },
    { value: 3, text: 'United Kingdom' },
    { value: 4, text: 'Other' },
]

const sickPolicyOptions = [
    { value: 85, text: 'Minimum by Law' },
    { value: 86, text: 'Employer/Company Policy In Place' },
    { value: 87, text: 'Frontload' },
    { value: 88, text: 'Exempt from Sick time' },
]

export default {
    name: new DefaultInput('Name'),
    name_legal: new DefaultInput('Legal Name'),
    name_reports: new DefaultInput('Name on Reports'),
    tin: new DefaultInput('Tax ID #'),
    parent_id: new DefaultFormAutocomplete('Parent Company', EntitiesResource, 'parent_id', { entity_type_id: 1 }),
    propay_id: new DefaultInput('Propay ID'),
    ext_payroll_id: new DefaultInput('Apex Client'),
    ext_payroll_union_id: new DefaultInput('Apex Union Client'),

    main_address1: new DefaultInput('Address Line 1'),
    main_address2: new DefaultInput('Address Line 2'),
    main_city: new DefaultInput('City'),
    main_state_id: new DefaultFormAutocomplete('State', StateResource, 'main_state_id'),
    main_postal: new DefaultInput('Postal Code'),
    main_country_id: new DefaultFormSelect('Country', countryOptions, 'country_id'),

    company_id: new DefaultFormSelect('Company', companyOptions, 'company_id'),
    org_type_id: new DefaultFormSelect('Organization Type', orgTypeOptions, 'org_type_id'),
    entity_type_id: new DefaultFormSelect('Entity Type', entityTypeOptions, 'entity_type_id'),
    industry_type_id: new DefaultFormSelect('Industry Type', industryTypeOptions, 'industry_type_id'),
    pay_frequency_id: new DefaultFormSelect('Default Pay Freq', payFrequencyTypeOptions, 'pay_frequency_id'),
    week_ending_id: new DefaultFormSelect('Default Week Ending', defaultWeekEndingOptions, 'week_ending_id'),
    dd_enabled: new DefaultFormSelect('Direct Deposit Enabled', booleanSelectOptions, 'dd_enabled'),
    certification_enabled: new DefaultFormSelect('Harassment Certfication Enabled', booleanSelectOptions, 'certification_enabled'),

    budget: new DefaultInput('Show Budget'),
    principal_start_date: new DefaultInput('Principal Start Date'),
    principal_end_date: new DefaultInput('Principal End Date'),
    prep_start_date: new DefaultInput('Prep Start Date', 'YYYY-MM-DD'),
    prep_end_date: new DefaultInput('Prep End Date', 'YYYY-MM-DD'),
    post_start_date: new DefaultInput('Post Start Date', 'YYYY-MM-DD'),
    post_end_date: new DefaultInput('Post End Date', 'YYYY-MM-DD'),

    status: new DefaultFormSelect('Status', booleanSelectOptions, 'status'),
    send_notifications: new DefaultFormSelect('Send Notifications', booleanSelectOptions, 'send_notifications'),

    sick_policy_id: new DefaultFormSelect('Sick Policy', sickPolicyOptions, 'sick_policy_id'),
    master_sick_entity: new DefaultFormAutocomplete('Master Sick Company', EntitiesResource, 'master_sick_entity', { entity_type_id: 1 }),
    master_vacation_entity: new DefaultFormAutocomplete('Master Vacation Company', EntitiesResource, 'master_vacation_entity', { entity_type_id: 1 }),
    master_holiday_entity: new DefaultFormAutocomplete('Master Holiday Company', EntitiesResource, 'master_holiday_entity', { entity_type_id: 1 }),
}

const parentCompanyFormSet = {
    parent_id: new DefaultFormAutocomplete('Parent Company', EntitiesResource, 'parent_id', { entity_type_id: 1 }),
    ext_payroll_id: new DefaultInput('Apex Client'),
    ext_payroll_union_id: new DefaultInput('Apex Union Client'),
    tin: new DefaultInput('Tax ID #'),
    org_type_id: new DefaultFormSelect('Organization Type', orgTypeOptions, 'org_type_id'),
    industry_type_id: new DefaultFormSelect('Industry Type', industryTypeOptions, 'industry_type_id'),
    company_id: new DefaultFormSelect('Company', companyOptions, 'company_id'),
    main_address1: new DefaultInput('Address Line 1'),
    main_address2: new DefaultInput('Address Line 2'),
    main_city: new DefaultInput('City'),
    main_state_id: new DefaultFormAutocomplete('State', StateResource, 'main_state_id'),
    main_postal: new DefaultInput('Postal Code'),
    main_country_id: new DefaultInput('Country'),

    signatory_propay_id: new DefaultInput('Crew Signatory Propay Project ID'),
    name_signatory: new DefaultInput('Crew Signatory Name'),
    tin_signatory: new DefaultInput('Crew Sig Tax ID #'),
    signatory_address1: new DefaultInput('Crew Sig Address Line 1'),
    signatory_address2: new DefaultInput('Crew Sig Address Line 2'),
    signatory_city: new DefaultInput('Crew Sig City'),
    signatory_state_id: new DefaultFormAutocomplete('Crew Sig State', StateResource, 'signatory_state_id'),
    signatory_postal: new DefaultInput('Crew Sig Postal Code'),
    signatory_country_id: new DefaultInput('Sig Country'),

    dga_signatory_propay_id: new DefaultInput('DGA Signatory Propay Project ID'),
    name_dga_signatory: new DefaultInput('DGA Sig Name'),
    tin_dga_signatory: new DefaultInput('DGA Sig Tax ID #'),
    dga_signatory_address1: new DefaultInput('DGA Sig Address Line 1'),
    dga_signatory_address2: new DefaultInput('DGA Sig Address Line 2'),
    dga_signatory_city: new DefaultInput('DGA Sig City'),
    dga_signatory_state_id: new DefaultFormAutocomplete('DGA Sig State', StateResource, 'dga_signatory_state_id'),
    dga_signatory_postal: new DefaultInput('DGA Sig Postal Code'),
    dga_signatory_country_id: new DefaultInput('DGA Sig Country'),

    sag_signatory_propay_id: new DefaultInput('SAG Signatory Propay Project ID'),
    name_sag_signatory: new DefaultInput('SAG Sig Name'),
    tin_sag_signatory: new DefaultInput('SAG Sig Tax ID #'),
    sag_signatory_address1: new DefaultInput('SAG Sig Address Line 1'),
    sag_signatory_address2: new DefaultInput('SAG Sig Address Line 2'),
    sag_signatory_city: new DefaultInput('SAG Sig City'),
    sag_signatory_state_id: new DefaultFormAutocomplete('SAG Sig State', StateResource, 'sag_signatory_state_id'),
    sag_signatory_postal: new DefaultInput('SAG Sig Postal Code'),
    sag_signatory_country_id: new DefaultInput('SAG Sig Country'),

    wga_signatory_propay_id: new DefaultInput('WGA Signatory Propay Project ID'),
    name_wga_signatory: new DefaultInput('WGA Sig Name'),
    tin_wga_signatory: new DefaultInput('WGA Sig Tax ID #'),
    wga_signatory_address1: new DefaultInput('WGA Sig Address Line 1'),
    wga_signatory_address2: new DefaultInput('WGA Sig Address Line 2'),
    wga_signatory_city: new DefaultInput('WGA Sig City'),
    wga_signatory_state_id: new DefaultFormAutocomplete('WGA Sig State', StateResource, 'wga_signatory_state_id'),
    wga_signatory_postal: new DefaultInput('WGA Sig Postal Code'),
    wga_signatory_country_id: new DefaultInput('WGA Sig Country'),
}

const showNamesFormSet = {
    name: new DefaultInput('Name'),
    name_legal: new DefaultInput('Legal Name'),
    name_reports: new DefaultInput('Name on Reports'),
    default_overtime_id: new DefaultInput('Default Non-CA Rule'),
    other_properties: new DefaultTextarea('other', '', 5),
    entity_type_id: new DefaultFormSelect('Entity Type', entityTypeOptions, 'entity_type_id'),
    propay_id: new DefaultInput('Propay Project ID'),
    pay_frequency_id: new DefaultFormSelect('Default Pay Freq', payFrequencyTypeOptions, 'pay_frequency_id'),
    week_ending_id: new DefaultFormSelect('Default Week Ending', defaultWeekEndingOptions, 'week_ending_id'),
    pay_date_basis: new DefaultToolTip('Pay Date Basis', 'The Pay Date Basis indicates the final date of the pay period. If bi-weekly, it is the end of the 2nd week.', 'pay_date_basis', 'YYYY-MM-DD'),
    union_prior_year_agreements: new DefaultInput('Prior Year Agreements'),
    dd_enabled: new DefaultFormSelect('Direct Deposit Enabled', booleanSelectOptions, 'dd_enabled'),
    certification_enabled: new DefaultFormSelect('Harassment Certfication Enabled', booleanSelectOptions, 'certification_enabled'),
    budget: new DefaultInput('Show Budget'),
    principal_start_date: new DefaultInput('Principal Start Date'),
    principal_end_date: new DefaultInput('Principal End Date'),
    prep_start_date: new DefaultInput('Prep Start Date', 'YYYY-MM-DD'),
    prep_end_date: new DefaultInput('Prep End Date', 'YYYY-MM-DD'),
    post_start_date: new DefaultInput('Post Start Date', 'YYYY-MM-DD'),
    post_end_date: new DefaultInput('Post End Date', 'YYYY-MM-DD'),
    status: new DefaultFormSelect('Status', booleanSelectOptions, 'status'),
}

const otherPropertiesFieldSet = {
    showBatches: new DefaultCheckbox('Show Batches'),
    showAccounts: new DefaultCheckbox('Show Accounts on Timecard Day'),
    employeeAllowancesLocked: new DefaultCheckbox('Allow Employee Allowances'),
    allowNegativeAccrual: new DefaultCheckbox('Allow Negative Accruals for Sick/Vac'),
    sendNotificationsWithCompanyName: new DefaultCheckbox('Send Notifications with Company Name'),
    overrideMPs: new DefaultCheckbox('Allow MP Override'),
    hideMissingTimecards: new DefaultCheckbox('Hide Missing Timecards'),
}

export { parentCompanyFormSet, showNamesFormSet, otherPropertiesFieldSet }
